import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AudienceFilter, AudiencePreview } from '../models/audience-filter.model';
import { Campaign } from '../models/campaign.model';
import { CampaignInput } from '../models/campaign-input.model';
import { CampaignKpi } from '../models/campaign-kpi.model';
import { CampaignListQuery } from '../models/campaign-list-query.model';
import { CampaignListResult } from '../models/campaign-list-result.model';
import { CampaignRecipient } from '../models/campaign-recipient.model';
import { EmailPreviewRequest } from '../models/email-preview-request.model';

export interface ICampaignsRepository {
  list(organizationId: number, query: CampaignListQuery): Observable<CampaignListResult>;
  getKpis(organizationId: number): Observable<CampaignKpi>;
  getById(organizationId: number, campaignId: string): Observable<Campaign>;
  getRecipients(organizationId: number, campaignId: string): Observable<readonly CampaignRecipient[]>;
  previewAudience(organizationId: number, filter: AudienceFilter): Observable<AudiencePreview>;
  // Raw HTML string -- see EmailPreviewRequest's doc comment: the backend endpoint returns the
  // rendered email body directly, not a `{ html }` envelope.
  previewEmail(organizationId: number, request: EmailPreviewRequest): Observable<string>;
  create(organizationId: number, input: CampaignInput): Observable<Campaign>;
  update(organizationId: number, campaignId: string, input: CampaignInput): Observable<Campaign>;
  delete(organizationId: number, campaignId: string): Observable<void>;
  duplicate(organizationId: number, campaignId: string): Observable<Campaign>;
  pause(organizationId: number, campaignId: string): Observable<Campaign>;
  schedule(organizationId: number, campaignId: string, scheduledAtUtc: string): Observable<Campaign>;
  sendNow(organizationId: number, campaignId: string): Observable<Campaign>;
}

export const CAMPAIGNS_REPOSITORY = new InjectionToken<ICampaignsRepository>('ICampaignsRepository');
